import { render } from "./indexSpace.vue?vue&type=template&id=1c08cdc0"
import script from "./indexSpace.vue?vue&type=script&lang=js"
export * from "./indexSpace.vue?vue&type=script&lang=js"

import exportComponent from "/home/afreet/public_html/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__